export type PlanCardAccent = 'green' | 'purple' | 'teal';

export const planAccentStyles: Record<
  PlanCardAccent,
  {
    ring: string;
    iconBg: string;
    gradient: string;
    cta: string;
    button: string;
  }
> = {
  green: {
    ring: 'hover:ring-[#7ED99C]/50',
    iconBg: 'bg-[#7ED99C]/15 text-[#3d8f5c]',
    gradient: 'from-[#7ED99C]/10 to-transparent',
    cta: 'text-[#3d8f5c]',
    button:
      'bg-[#4A7C75] text-white hover:bg-[#3d6560] focus-visible:ring-[#4A7C75]',
  },
  purple: {
    ring: 'hover:ring-[#A56096]/50',
    iconBg: 'bg-[#A56096]/15 text-[#A56096]',
    gradient: 'from-[#A56096]/10 to-transparent',
    cta: 'text-[#A56096]',
    button:
      'bg-[#A56096] text-white hover:bg-[#8a4f7f] focus-visible:ring-[#A56096]',
  },
  teal: {
    ring: 'hover:ring-[#4A7C75]/50',
    iconBg: 'bg-[#4A7C75]/15 text-[#4A7C75]',
    gradient: 'from-[#4A7C75]/10 to-transparent',
    cta: 'text-[#4A7C75]',
    button:
      'bg-[#4A7C75] text-white hover:bg-[#3d6560] focus-visible:ring-[#4A7C75]',
  },
};

export const hubPlanCardShell = (ring: string, featured?: boolean) =>
  `group relative flex h-full w-full flex-col rounded-3xl bg-white p-6 text-left shadow-lg ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:p-8 ${ring} ${
    featured ? 'ring-2 ring-[#7ED99C]/60' : ''
  }`;

export function planAccentForDisplay(plan: {
  isFeatured?: boolean;
  isRecurring?: boolean;
}): PlanCardAccent {
  if (plan.isFeatured) return 'green';
  if (plan.isRecurring) return 'purple';
  return 'teal';
}
